import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=52fb814a&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "../assets/css/statistics.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Statistics.vue?vue&type=style&index=1&id=52fb814a&prod&lang=scss"
import style2 from "./Statistics.vue?vue&type=style&index=2&id=52fb814a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fb814a",
  null
  
)

export default component.exports